function updateHeaderHeight() {
  const headerWrapper = document.querySelector('.header-wrapper');
  if (headerWrapper) {
    document.documentElement.style.setProperty('--not-stickty-header-height', headerWrapper.offsetHeight + 'px');
  }
}
updateHeaderHeight();
window.addEventListener('load', updateHeaderHeight);
window.addEventListener('resize', updateHeaderHeight);

document.addEventListener('DOMContentLoaded', function () {
  const customSelects = document.querySelectorAll('.custom-select');
  customSelects.forEach((customSelect) => {
    const trigger = customSelect.querySelector('.custom-select-trigger');
    const options = customSelect.querySelectorAll('.custom-options .custom-option');
    const selectedCountrySpan = trigger.querySelector('.selected_country');
    trigger.addEventListener('click', function (event) {
      event.stopPropagation();
      const isOpen = customSelect.classList.contains('open');
      closeAllSelects();
      if (!isOpen) {
        customSelect.classList.add('open');
      }
    });
    options.forEach((option) => {
      option.addEventListener('click', function (event) {
        event.stopPropagation();
        const selectedImageSrc = this.querySelector('.countryimage img').getAttribute('src');
        trigger.querySelector('img').setAttribute('src', selectedImageSrc);
        trigger.querySelector('img').setAttribute('srcset', selectedImageSrc);
        const selectedCountryName = this.getAttribute('data-name');
        selectedCountrySpan.textContent = selectedCountryName;
        customSelect.classList.remove('open');
      });
    });
  });
  document.addEventListener('click', function (event) {
    closeAllSelects();
  });
  function closeAllSelects() {
    customSelects.forEach((customSelect) => {
      customSelect.classList.remove('open');
    });
  }
});

document.addEventListener('DOMContentLoaded', () => {
  const tabButtons = document.querySelectorAll('.outfit-tab-button');
  const tabContents = document.querySelectorAll('.outfit-tab-content');

  tabButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const targetTab = button.getAttribute('data-tab');

      if (document.querySelector('.outfit-tab-button.active')) {
        document.querySelector('.outfit-tab-button.active').classList.remove('active');
      }
      if (document.querySelector('.outfit-tab-content.active')) {
        document.querySelector('.outfit-tab-content.active').classList.remove('active');
      }
      button.classList.add('active');
      document.getElementById(targetTab).classList.add('active');
      const targetEl = document.getElementById(targetTab);
      if (targetEl) {
        targetEl
          .querySelectorAll(
            '.swiper, .outfit-tabs-product-slider, .outfit-tabs-product-slider-lookbook, .prod-images-slider-lookbook'
          )
          .forEach((el) => {
            if (el.swiper) {
              el.swiper.destroy(true, true);
              el.swiper = null;
            }
          });
      }
      if (document.querySelector(`[data-tabid="${targetTab}"]`)) {
        document.getElementById(targetTab).innerHTML = document.querySelector(`[data-tabid="${targetTab}"]`).innerHTML;
      }
      main_pro_card_slider();
      product_images_slider();
      scrollToClosestActive(targetTab);
      main_pro_card_slider_outfit();
      morecolorShow();
    });
  });
});

function scrollToClosestActive(targetTab) {
  setTimeout(() => {
    window.scrollTo({
      top: document.getElementById(targetTab).offsetTop,
      behavior: 'smooth'
    });
  }, 200);
}

document.addEventListener('DOMContentLoaded', function () {
  const bottom = document.querySelector('.outfit-tabs-bottom-slider');
  if (bottom && bottom.swiper) return;
  const slideCount = bottom ? bottom.querySelectorAll(':scope > .swiper-wrapper > .swiper-slide').length : 0;
  const isDesktop = window.innerWidth >= 750;
  const spv = isDesktop ? 4 : 2.09;
  const minimumLoopSlides = Math.ceil(spv) + 1;
  const mySwiper = new Swiper('.outfit-tabs-bottom-slider', {
    spaceBetween: 8,
    slidesPerView: 2.09,
    roundLengths: true,
    loop: slideCount >= minimumLoopSlides,
    breakpoints: {
      750: {
        slidesPerView: 4,
        spaceBetween: 8
      }
    },
    navigation: {
      nextEl: '.outfit-tabs-next',
      prevEl: '.outfit-tabs-prev',
      addIcons: false
    },
    on: {
      slideChange: function () {
        if (window.innerWidth < 750 && this.slides[this.activeIndex]) {
          this.slides[this.activeIndex].querySelector('.outfit-tab-button').click();
        }
      }
    }
  });
  if (bottom) bottom.swiper = mySwiper;
});
function main_pro_card_slider() {
  document
    .querySelectorAll('.outfit-tab-content.active .outfit-tabs-product-slider-lookbook')
    .forEach(function (slider) {
      if (slider.swiper) return;
      const parent = slider.closest('.main_pro_card_slider-lookbook');
      const nextEl = parent?.querySelector('.mainslide-next');
      const prevEl = parent?.querySelector('.mainslide-prev');
      const pagEl = parent?.querySelector('.swiper-pagination');
      const slideCount = slider.querySelectorAll(':scope > .swiper-wrapper > .swiper-slide').length;
      const swiper = new Swiper(slider, {
        spaceBetween: 0,
        slidesPerView: 2.05,
        roundLengths: true,
        loop: false,
        breakpoints: {
          750: {
            slidesPerView: 1,
            spaceBetween: 8
          }
        },
        ...(nextEl && prevEl ? { navigation: { nextEl, prevEl, addIcons: false } } : {}),
        pagination: {
          el: pagEl,
          clickable: true
        }
      });
      slider.swiper = swiper;
    });
}
document.addEventListener('DOMContentLoaded', function () {
  main_pro_card_slider_outfit();
});
function main_pro_card_slider_outfit() {
  document.querySelectorAll('.outfit-tab-content.active .outfit-tabs-product-slider').forEach(function (slider) {
    if (slider.swiper) return;
    const slideCount = slider.querySelectorAll(':scope > .swiper-wrapper > .swiper-slide').length;
    const navParent = slider.closest('.main_pro_card_slider');
    const nextEl = navParent?.querySelector('.mainslide-next');
    const prevEl = navParent?.querySelector('.mainslide-prev');
    const pagEl = navParent?.querySelector('.swiper-pagination-main');
    const isDesktop = window.innerWidth >= 750;
    const spv = isDesktop ? 1 : 2.04;
    const minimumLoopSlides = Math.ceil(spv) + 1;
    const swiper = new Swiper(slider, {
      spaceBetween: 0,
      slidesPerView: 2.04,
      roundLengths: true,
      loop: slideCount >= minimumLoopSlides,
      breakpoints: {
        750: {
          slidesPerView: 1,
          spaceBetween: 8
        }
      },
      ...(nextEl && prevEl ? { navigation: { nextEl, prevEl, addIcons: false } } : {}),
      pagination: {
        el: pagEl,
        clickable: true
      },
      on: {
        slideChange: function () {
          this.pagination && this.pagination.update();
          handleSwiper();
        }
      }
    });
    slider.swiper = swiper;
  });
}
let cardSwiperObserver = null;

function promoteCardSwiperSlide(slide) {
  if (!slide) return;
  slide.querySelectorAll('img[data-src], img[data-srcset]').forEach((image) => {
    if (image.dataset.srcset) {
      image.srcset = image.dataset.srcset;
      image.removeAttribute('data-srcset');
    }
    if (image.dataset.src) {
      image.src = image.dataset.src;
      image.removeAttribute('data-src');
    }
  });
}

function hydrateCardSwiper(container) {
  if (!container.swiper) {
    container.swiper = initSwiper(container);
  }
}

// Lazy-hydrate product-card sliders: only spin up Swiper when a card nears the
// viewport, instead of initialising every card on load (a single long task).
function lazyHydrateSwipers(containers) {
  if (!('IntersectionObserver' in window)) {
    containers.forEach(hydrateCardSwiper);
    return;
  }

  // Disconnect any prior observer to release references to DOM nodes that may
  // have been removed by an AJAX re-render (sort, facets, predictive-search).
  if (cardSwiperObserver) {
    cardSwiperObserver.disconnect();
  } else {
    cardSwiperObserver = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            hydrateCardSwiper(entry.target);
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '300px 0px' }
    );
  }

  // Re-observe all containers with the (possibly reused) observer.
  containers.forEach((container) => {
    if (!container.swiper) {
      cardSwiperObserver.observe(container);
    }
  });
}

function handleSwiper() {
  const swiperContainers = Array.from(document.querySelectorAll('.prod-images-slider'));
  const eligibleContainers = swiperContainers.filter((container) => {
    const sliderWrapper = container.closest('[js-featured-collection="slider-container"]');
    const isMobileDisabled = sliderWrapper?.hasAttribute('gallery-swiper-mobile');

    if (!isMobileDisabled || window.innerWidth >= 1024) return true;

    container.swiper?.destroy(true, true);
    container.swiper = null;
    return false;
  });

  lazyHydrateSwipers(eligibleContainers);
}

function hydrateProductGridSliders() {
  if (
    document.getElementById('product-grid') &&
    typeof Shopify !== 'undefined' &&
    typeof Shopify.cardProductSlider === 'function'
  ) {
    Shopify.cardProductSlider('#product-grid .prod-images-slider');
  }
  // Always run handleSwiper so .prod-images-slider elements outside #product-grid
  // (e.g. featured-collection sections added via the theme editor) are initialised.
  handleSwiper();
}

function initSwiper(container) {
  const parent = container.closest('.card__media');
  if (!parent) return null;
  const paginationEl = parent.querySelector('.swiper-pagination');
  const nextEl = parent.querySelector('.images_sliderbtn.swiper-button-next');
  const prevEl = parent.querySelector('.images_sliderbtn.swiper-button-prev');
  const slideCount = container.querySelectorAll(':scope > .swiper-wrapper > .swiper-slide').length;
  const swiper = new Swiper(container, {
    loop: slideCount > 1,
    slidesPerView: 1,
    allowTouchMove: true,
    breakpoints: {
      750: {
        allowTouchMove: !document.body.classList.contains('product')
      }
    },
    pagination: {
      el: paginationEl,
      clickable: true
    },
    ...(nextEl && prevEl ? { navigation: { nextEl, prevEl, addIcons: false } } : {})
  });
  const promoteAdjacent = () => {
    const slides = swiper.slides;
    const index = swiper.activeIndex;
    const count = slides.length;
    promoteCardSwiperSlide(slides[index]);
    promoteCardSwiperSlide(slides[(index - 1 + count) % count]);
    promoteCardSwiperSlide(slides[(index + 1) % count]);
  };
  promoteAdjacent();
  swiper.on('slideChange', function () {
    promoteAdjacent();
    swiper.pagination && swiper.pagination.update();
  });
  return swiper;
}

document.addEventListener('DOMContentLoaded', function () {
  hydrateProductGridSliders();
  window.addEventListener(
    'resize',
    debounce(function () {
      const grid = document.getElementById('product-grid');
      if (grid && typeof Shopify !== 'undefined' && typeof Shopify.cardProductSlider === 'function') {
        Shopify.cardProductSlider('#product-grid .prod-images-slider');
      }
      // Always re-evaluate sliders outside the product grid on resize.
      handleSwiper();
    }, 300)
  );
});
function product_images_slider() {
  const swiperContainers = document.querySelectorAll('.outfit-tab-content.active .prod-images-slider-lookbook');
  swiperContainers.forEach(function (container) {
    if (container.swiper) return;
    const parent = container.closest('.card__media');
    if (!parent) return;
    const paginationEl = parent.querySelector('.swiper-pagination');
    const nextEl = parent.querySelector('.images_sliderbtn.swiper-button-next');
    const prevEl = parent.querySelector('.images_sliderbtn.swiper-button-prev');
    const slideCount = container.querySelectorAll(':scope > .swiper-wrapper > .swiper-slide').length;
    const swiper = new Swiper(container, {
      loop: slideCount > 1,
      slidesPerView: 1,
      allowTouchMove: true,
      breakpoints: {
        750: {
          allowTouchMove: false
        }
      },
      pagination: {
        el: paginationEl,
        clickable: true
      },
      ...(nextEl && prevEl ? { navigation: { nextEl, prevEl, addIcons: false } } : {})
    });
    swiper.on('slideChange', function () {
      swiper.pagination && swiper.pagination.update();
    });
    container.swiper = swiper;
  });
}

function toggleDescription() {
  document.querySelector('.mobile_sort_description').style.display = 'none';
  document.querySelector('.mobile_full_description').style.display = 'block';
  document.querySelector('.readmore').style.display = 'none';
}

document.addEventListener('DOMContentLoaded', function () {
  if (document.querySelector('.color_opt')) {
    document.querySelector('.color_opt').innerHTML = ' ' + document.querySelector('.color_select').value;
    document.querySelector(
      '.color-variants-wrapper input[value="' + document.querySelector('.color_select').value + '"]'
    ).checked = true;
    document.querySelectorAll('input[name="radio-color-group"]').forEach(function (radio) {
      radio.addEventListener('click', function () {
        document.querySelector('.color_opt').innerHTML = ' ' + this.value;
        document.querySelector('.color_select').value = this.value;
        const event = new Event('change', {
          bubbles: true
        });
        document.querySelector('.color_select').dispatchEvent(event);
      });
    });
  }
});
document.addEventListener('DOMContentLoaded', function () {
  const buyButtonsText = document.querySelector('.buy_buttons_text');
  if (buyButtonsText) {
    const productForm = buyButtonsText.querySelector('.product-form');
    if (productForm) {
      let productFormHeight = productForm.offsetHeight;

      window.addEventListener('resize', () => (productFormHeight = productForm.offsetHeight));

      window.addEventListener(
        'scroll',
        () => {
          if (window.scrollY >= productFormHeight + 150) {
            buyButtonsText.classList.remove('sticky');
          } else {
            buyButtonsText.classList.add('sticky');
          }
        },
        { passive: true }
      );
    }
  }
});
function editQty() {
  if (window.editQtyInitialized) return;
  window.editQtyInitialized = true;

  document.addEventListener('click', function (event) {
    const btn = event.target.closest('.editbtn');
    if (!btn) return;

    document.querySelectorAll('.cart-item quantity-popover').forEach(function (prover) {
      if (prover.closest('.cart_items')) {
        prover.classList.add('hide');
      }
    });
    document.querySelectorAll('.cart-item .itemqty').forEach(function (itemqty) {
      itemqty.classList.remove('hide');
    });

    const cartItem = btn.closest('.cart-item');
    if (cartItem && cartItem.querySelector('quantity-popover')) {
      cartItem.querySelector('quantity-popover').classList.remove('hide');
      cartItem.querySelector('.itemqty').classList.add('hide');
    }
  });
}
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.outlook_image_slide_prev').forEach(function (element) {
    element.addEventListener('click', function () {
      document.querySelector('.outfit-tabs-bottom-slider .outfit-tabs-prev').click();
    });
  });
  document.querySelectorAll('.outlook_image_slide_next').forEach(function (element) {
    element.addEventListener('click', function () {
      document.querySelector('.outfit-tabs-bottom-slider .outfit-tabs-next').click();
    });
  });
});

document.addEventListener('DOMContentLoaded', editQty);

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', klarnaStyle);
} else {
  klarnaStyle();
}

function klarnaStyle() {
  if (window.__klarnaStyleInitialized) return;
  window.__klarnaStyleInitialized = true;

  const originalAttachShadow = Element.prototype.attachShadow;
  if (originalAttachShadow && !originalAttachShadow._patchedByKlarna) {
    Element.prototype.attachShadow = function (init) {
      const shadowRoot = originalAttachShadow.call(this, init);
      if (this.tagName === 'KLARNA-PLACEMENT') {
        observeShadow(this);
      }
      return shadowRoot;
    };
    Element.prototype.attachShadow._patchedByKlarna = true;
  }

  const processNewPlacements = () => {
    const placements = document.querySelectorAll('klarna-placement:not([data-observed])');
    if (placements.length === 0) return;

    placements.forEach((klarnaPlacement) => {
      klarnaPlacement.setAttribute('data-observed', 'true');
      if (klarnaPlacement.shadowRoot) {
        observeShadow(klarnaPlacement);
      }
    });
  };

  const mainObserver = new MutationObserver((mutations) => {
    if (
      mutations.some((mutation) =>
        [...mutation.addedNodes].some(
          (node) => node.tagName === 'KLARNA-PLACEMENT' || node.querySelector?.('klarna-placement')
        )
      )
    ) {
      processNewPlacements();
    }
  });

  function observeShadow(klarnaPlacement) {
    if (klarnaPlacement.hasAttribute('data-shadow-observed')) return;
    const shadowRoot = klarnaPlacement.shadowRoot;
    if (!shadowRoot) return;
    if (klarnaPlacement.hasAttribute('data-styled')) return;

    klarnaPlacement.setAttribute('data-shadow-observed', 'true');

    const shadowObserver = new MutationObserver(() => {
      const applied = tryApplyStyles(shadowRoot, klarnaPlacement);
      if (applied) {
        shadowObserver.disconnect();
      }
    });

    shadowObserver.observe(shadowRoot, { childList: true, subtree: true });

    const applied = tryApplyStyles(shadowRoot, klarnaPlacement);
    if (applied) {
      shadowObserver.disconnect();
    }
  }

  function tryApplyStyles(shadowRoot, klarnaPlacement) {
    const styleRules = [
      {
        selector: '.container',
        styles: { borderColor: 'transparent', padding: '0', alignItems: 'flex-start', justifyContent: 'center' }
      },
      { selector: '#osm-klarna-title', styles: { width: '47px', borderRadius: '4px', backgroundColor: '#ffa8cd' } },
      {
        selector: '.text-wrapper',
        styles: { fontSize: '10px', marginLeft: '10px', fontWeight: '700', lineHeight: '11px', letterSpacing: '0' }
      },
      {
        selector: 'button.link',
        styles: { fontSize: '10px', fontWeight: '700', lineHeight: '11px', letterSpacing: '0.02em', marginLeft: '2px' }
      },
      {
        selector: '.legal',
        styles: { fontSize: '10px', color: '#0B0B0B', fontWeight: '400', lineHeight: '11px', letterSpacing: '0.02em' }
      }
    ];

    let allSelectorsApplied = true;
    styleRules.forEach(({ selector, styles }) => {
      const element = shadowRoot.querySelector(selector);
      if (element) {
        let needsUpdate = false;
        for (const [key, val] of Object.entries(styles)) {
          if (element.style[key] !== val) {
            needsUpdate = true;
            break;
          }
        }
        if (needsUpdate) {
          Object.assign(element.style, styles);
        }

        // Accessibility improvements for the button
        if (selector === 'button.link' || selector === 'a.link') {
          if (selector === 'a.link') {
            if (!element.hasAttribute('role')) {
              element.setAttribute('role', 'button');
            }
            if (!element.hasAttribute('tabindex')) {
              element.setAttribute('tabindex', '0');
            }
          }

          // Add focus indicator if not already styled for focus
          if (!element.dataset.focusStyled) {
            element.addEventListener('focus', () => {
              element.style.setProperty('outline', '2px solid #000', 'important');
              element.style.setProperty('outline-offset', '2px', 'important');
            });
            element.addEventListener('blur', () => {
              element.style.removeProperty('outline');
              element.style.removeProperty('outline-offset');
            });
            element.dataset.focusStyled = 'true';
          }
        }
      } else {
        allSelectorsApplied = false;
      }
    });

    if (allSelectorsApplied) {
      klarnaPlacement.classList.remove('hide');
      klarnaPlacement.setAttribute('data-styled', 'true');
      return true;
    }
    return false;
  }

  mainObserver.observe(document.body, { childList: true, subtree: true });

  processNewPlacements();
}
document.querySelector('.header__icon--search').addEventListener('click', function () {
  document.querySelector('.search__input.field__input').blur();
});
document.querySelector('.search-modal__form').addEventListener('touchmove', (event) => {
  document.getElementById('Search-In-Modal').blur();
});
document.querySelector('.search-modal__form').addEventListener('scroll', (event) => {
  document.getElementById('Search-In-Modal').blur();
});
